module.exports = __webpack_public_path__ + "img/vehicleCircleMetro.8ebeed7e.svg";